import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
// import counterReducer from '../features/counter/counterSlice';
import formAfterSignUpReducer from '../features/formAfterSignUp/formAfterSignUpSlice';
import authReducer from '../features/authentication/authSlice';
import packageReducer from '../features/packages/packagesSlice';
import { businessRegistration } from '../features/businessRegistration/businessRegistrationSlice';
import { businessInformation } from '../features/businessInformation/businessInformationSlice';
import { twoFAenable } from '../features/2FAenable/2FAenableSlice';
import navbarReducer from '../features/navbarToggler/navbarSlice';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};
const rootReducer = combineReducers({
  formAfterSignUp: formAfterSignUpReducer,
  auth: authReducer,
  packages: packageReducer,
  [businessRegistration.reducerPath]: businessRegistration.reducer,
  [businessInformation.reducerPath]: businessInformation.reducer,
  [twoFAenable.reducerPath]: twoFAenable.reducer,
  button: navbarReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      businessRegistration.middleware,
      businessInformation.middleware,
      twoFAenable.middleware,
    ),
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
